import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouterExtensions } from '@luggagehero/core';
import { ShopManagerBaseComponent } from '@luggagehero/features/shop-manager';
import { CurrencyService, StorageManagerService } from '@luggagehero/services';
import { SharedIntercomService } from '@luggagehero/shared/services/intercom';
import { SharedPageTaggingService } from '@luggagehero/shared/services/page-tagging';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-shop-manager',
  templateUrl: 'shop-manager.component.html',
  styleUrls: ['shop-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopManagerComponent extends ShopManagerBaseComponent {
  constructor(
    formBuilder: FormBuilder,
    storageManagerService: StorageManagerService,
    userService: SharedUserService,
    currencyService: CurrencyService,
    router: RouterExtensions,
    route: ActivatedRoute,
    intercom: SharedIntercomService,
    window: SharedWindowService,
    translate: TranslateService,
    tag: SharedPageTaggingService,
    cd: ChangeDetectorRef,
    sharedStorageService: SharedStorageService,
  ) {
    super(
      formBuilder,
      storageManagerService,
      userService,
      currencyService,
      router,
      route,
      intercom,
      window,
      translate,
      tag,
      cd,
      sharedStorageService,
    );
  }
}
